import ImageOptimizer from '@/components/image-optimizer';
import CommonBrandStory from '../../components/common-brand-story';

interface UnlimitedBrandStoryProps {
  id: string;
}

export default function UnlimitedBrandStory({ id }: UnlimitedBrandStoryProps) {
  return (
    <div id={id} className="">
      {/**웹 */}
      <div
        className="desktop:flex desktop:py-30 hidden flex-col items-center justify-center bg-[#2E2D2D] pt-[100px] pb-[72px] font-semibold text-white"
        style={{
          backgroundImage: `url('/images/recommend-class/common/story_bg_pattern.svg')`,
          backgroundSize: '157px 302px',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'repeat-x',
        }}
      >
        <div className="desktop:typo-40 typo-28 desktop:mb-8 mb-5">
          면허취득 과정이 이렇게 <span className="font-extrabold">비싸야</span>{' '}
          하나요?
        </div>
        <div className="desktop:typo-28 typo-18 font-semibold text-[#E7E7E7]">
          면허를 따고 싶어도, 수 많은 걱정과 부담 되는 비용 때문에 망설여지진
          않나요?
        </div>
        <ImageOptimizer
          src="/images/recommend-class/unlimited/con_hero_new.webp"
          alt="brand story"
          width={1180}
          height={318}
          className="desktop:block mt-[52px] hidden"
        />
      </div>
      {/** 모바일 */}
      <div
        className="desktop:hidden flex flex-col items-center justify-center bg-[#2E2D2D] py-30 pt-[100px] pb-[72px] font-semibold text-white"
        style={{
          backgroundImage: `url('/images/recommend-class/common/story_bg_pattern.svg')`,
          backgroundSize: '78px 151px',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'repeat-x',
        }}
      >
        <div>
          <div className="desktop:typo-40 typo-28 desktop:mb-8 mb-4 text-center leading-snug">
            면허취득 과정이 이렇게
            <br />
            <span className="font-extrabold">비싸야</span> 하나요?
          </div>
          <div className="desktop:typo-28 typo-18 text-center leading-snug font-semibold text-[#E7E7E7]">
            면허를 따고 싶어도, 수 많은 걱정과 부담 되는
            <br />
            비용 때문에 망설여지진 않나요?
          </div>
          <ImageOptimizer
            src="/images/recommend-class/unlimited/mo_con_hero_new.webp"
            alt="brand story"
            width={327}
            height={362}
            className="desktop:hidden mt-[48px] block"
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center bg-[#F8F9FC]">
        <div className="desktop:w-[40px] desktop:h-[80px] desktop:mb-20 relative mb-[46px] h-[54px] w-[26px]">
          <ImageOptimizer
            src="/images/recommend-class/common/story_top_icon.svg"
            alt="top icon"
            fill
          />
        </div>
        {/**웹 */}
        <div className="desktop:flex hidden flex-col items-center justify-center">
          <div className="desktop:typo-28 typo-18 desktop:h-[86px] desktop:w-[820px] desktop:gap-1 flex flex-wrap items-center justify-center rounded-full bg-black font-semibold text-white">
            <div className="desktop:w-[23px] desktop:h-[14px] relative h-[9px] w-[16px]">
              <ImageOptimizer
                src="/images/recommend-class/common/img_left.svg"
                alt="left icon"
                fill
                className="desktop:-mt-[15px]"
              />
            </div>
            <span className="desktop:typo-36 font-semibold">
              이젠{' '}
              <span className="text-main-yellow font-extrabold">저렴 안전</span>
              하게 실내에서 운전면허 따요
            </span>
            <div className="desktop:w-[23px] desktop:h-[14px] relative h-[9px] w-[16px]">
              <ImageOptimizer
                src="/images/recommend-class/common/img_right.svg"
                alt="right icon"
                fill
                className="desktop:-mt-[15px]"
              />
            </div>
          </div>
          <div className="desktop:typo-28 desktop:gap-4 desktop:mt-[40px] desktop:mb-[80px] flex flex-col items-center justify-center font-semibold text-[#3F3F40]">
            <span>
              드라이빙존 운전면허는 전국23개 운전면허시험장 코스를 무제한 연습
              및 체계적인 커리큘럼을 제공하며,
            </span>
            <span>
              예비 취득자 및 운전이 두려운 분들께 운전의 자신감과 빠른
              면허취득을 지원합니다.
            </span>
          </div>
        </div>
        {/**모바일 */}
        <div className="desktop:hidden flex flex-col items-center justify-center">
          <div className="typo-18 flex h-[84px] w-[294px] flex-wrap items-center justify-center rounded-full bg-black font-semibold text-white">
            <div className="relative h-[9px] w-[16px]">
              <ImageOptimizer
                src="/images/recommend-class/common/img_left.svg"
                alt="left icon"
                fill
                className="-mt-[25px]"
              />
            </div>
            <span className="typo-22 flex flex-col items-center justify-center gap-2 font-semibold">
              <span>
                이젠{' '}
                <span className="text-main-yellow font-extrabold">
                  저렴 안전
                </span>
                하게
              </span>
              <span>실내에서 운전면허 따요</span>
            </span>
            <div className="relative h-[9px] w-[16px]">
              <ImageOptimizer
                src="/images/recommend-class/common/img_right.svg"
                alt="right icon"
                fill
                className="-mt-[25px]"
              />
            </div>
          </div>
          <div className="typo-18 mt-7 mb-8 flex flex-col items-center justify-center gap-2 font-semibold text-[#3F3F40]">
            <span>드라이빙존 운전면허는 전국 23개</span>
            <span>운전면허시험장 코스를 무제한 연습 및</span>
            <span>체계적인 커리큘럼을 제공하며,</span>
            <span>예비 취득자 및 운전이 두려운 분들께 운전의</span>
            <span>자신감과 빠른 면허취득을 지원합니다.</span>
          </div>
        </div>

        <CommonBrandStory />
      </div>
    </div>
  );
}
